import { useEffect } from 'react'
import { rememberRouteClickIntent } from '../logic/routeNavigationIntent'

/** Records the native click currently being dispatched for imperative route navigation. */
export function RouteNavigationController() {
  useEffect(() => {
    document.addEventListener('click', rememberRouteClickIntent, true)
    return () => document.removeEventListener('click', rememberRouteClickIntent, true)
  }, [])

  return null
}
